import script from "./ClearModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearModal.vue?vue&type=script&setup=true&lang=js"

import "./ClearModal.vue?vue&type=style&index=0&id=4dfeb88d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfeb88d"]])

export default __exports__